import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { PageService } from '@services/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  pageTitle$: Observable<string>;

  constructor(private titleService: Title,
              private router: Router,
              private pageService: PageService) {
    // select page title
    this.pageTitle$ = this.pageService.getPageTitleSelector();
    
    // set page url
    this.pageService.changePageInfo({ pageURL: this.router.url });
  }

  ngOnInit(): void {
    this.pageTitle$
      .subscribe(title => this.setTitle(title));
  }

  setTitle( newTitle: string): void {
    this.titleService.setTitle( newTitle + ' - Affiliate' );
  }

}
